import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { getCardIcon, getFormattedTime } from '../../utils/helper'

function ExtendDetails(props) {
    const { className, extendedDetails, paymentData } = props

    return (
        <div>
            {extendedDetails?.length > 0 && <div className={`${className}`}>
                <table className='table table-responsive small mt-2'>
                    {extendedDetails?.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    <span className="text-primary">{index == 0 && paymentData?.reservation?.thirdparty_integration_id === '1' ? 'Started(Paid at Aggregator)' : index == 0 ? 'Started' : paymentData?.is_overstay == '1' ? 'Overstay' : paymentData?.is_extended == '1' ? 'Extended' : 'Started'}</span>
                                    <small className="d-block text-muted"><i className="far fa-clock"></i>
                                        {` ${getFormattedTime(item?.length, false)} ${Number(item?.length) > 1 ? 'HRS' : Number(item?.length) == 1 ? 'HR' : 'MM'}`}
                                    </small>
                                </td>
                                <td className="text-end">
                                    {index == 0 ? `$${item?.total}` : ` $${Number(item?.total)?.toFixed(2)}`}<br />
                                    <img src={getCardIcon(item?.payment_method ? item?.payment_method : 'visa')} style={{height: '10px', padding: '0'}} alt="" />
                                </td>
                            </tr>
                        )
                    })}
                </table>

            </div>}
        </div>
    )
}

ExtendDetails.propTypes = {
    dispatch: PropTypes.func,
    className: PropTypes.string,
    extendedDetails: PropTypes.array,
    paymentData: PropTypes.object,
}

ExtendDetails.defaulProps = {
    dispatch: noop,
    className: '',
    extendedDetails: EMPTY_ARRAY,
    paymentData: EMPTY_OBJECT,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ExtendDetails)